module.exports = __webpack_public_path__ + "img/login.e41df167.png";